import React from "react";
import helpicon from "../../../images/helpicon.svg";
import { Tooltip } from "antd";

interface LabelProps {
  labelTitle: string;
  isHelpIconRequired: boolean;
  tooltipText?: string;
  isRequired?: boolean;
  htmlFor?: string;
}
const Label: React.FC<LabelProps> = ({ labelTitle, isHelpIconRequired, tooltipText, htmlFor, isRequired }) => {
  return (
    <>
      <label htmlFor={htmlFor} className="font-medium text-text-secondary text-sm cursor-pointer flex items-center">
        {labelTitle} {isRequired ? (<span className="text-primary ml-1 text-sm">*</span>) : (<></>)}
        {isHelpIconRequired ? (
          <Tooltip title={tooltipText}>
            <img src={helpicon} alt="Help Icon" className="ps-1 cursor-pointer" />
          </Tooltip>
        ) : (
          <></>
        )}
      </label>
    </>
  );
};

export default Label;
